import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {  MatButtonModule } from '@angular/material';
import {MatRadioModule} from '@angular/material/radio';
import {MatSliderModule} from '@angular/material/slider';
import {MatInputModule, MatTableModule, MatToolbarModule, MatSortModule,   MatPaginatorModule, } from '@angular/material';

@NgModule({
  imports: [MatButtonModule, MatRadioModule, MatSliderModule,CommonModule, MatToolbarModule, MatInputModule, MatTableModule,  MatSortModule,   MatPaginatorModule,],
  exports: [MatButtonModule, MatRadioModule, MatSliderModule, CommonModule, MatToolbarModule, MatInputModule, MatTableModule,  MatSortModule,   MatPaginatorModule,]
})
export class MaterialAppModule { }


// WEBPACK FOOTER //
// ./src/app/ngmaterial.module.ts